import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import {
  BoxModule,
  ButtonComponentModule,
  CardComponentModule,
  FlexBoxModule,
  FormFieldComponentModule,
  InputComponentModule,
  LanternRecaptchaModule,
  LinkModule,
  PageContainerComponentModule,
  TooltipModule
} from "@lantern/app/common";
import { GrowlComponentsModule } from "@lantern/app/common/utils/growl-components";
import { IconModule } from "@lantern/app/common/utils/icon";
import { ModalComponentsModule } from "@lantern/app/common/utils/modals";
import { UserActionDirectivesModule } from "@lantern/app/common/utils/user-action-directives";

import { LocalCommonModule } from "@local/app/common";
import { VerifyMagicTokenComponent } from "@local/app/pages/magic-token/verify-magic-token.component";

import { LoginComponent } from "./login";
import { LogoutComponent } from "./logout";
import { MartsComponent } from "./marts";
import { RequestResetPasswordComponent } from "./request-reset-password";
import { ResetPasswordComponent } from "./reset-password";
import { SetPasswordComponent } from "./set-password";
import { UserSettingsComponent } from "./user-settings";

const COMPONENTS = [
  MartsComponent,
  LoginComponent,
  LogoutComponent,
  RequestResetPasswordComponent,
  ResetPasswordComponent,
  SetPasswordComponent,
  UserSettingsComponent,
  VerifyMagicTokenComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IconModule,
    LocalCommonModule,
    RouterModule,
    ModalComponentsModule,
    UserActionDirectivesModule,
    GrowlComponentsModule,
    ReactiveFormsModule,

    ButtonComponentModule,
    FlexBoxModule,
    FormFieldComponentModule,
    InputComponentModule,
    LinkModule,
    CardComponentModule,
    PageContainerComponentModule,
    TooltipModule,
    BoxModule,
    LanternRecaptchaModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS
})
export class PagesModule {}
